"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const grid = {
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
  },
  containerWidths: {
    sm: 540,
    md: 720,
    lg: 960,
    xl: 1140
  },
  gutterWidth: 30
};
var _default = grid;
exports.default = _default;